import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=ebc826bc&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc826bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebc826bc')) {
      api.createRecord('ebc826bc', component.options)
    } else {
      api.reload('ebc826bc', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=ebc826bc&scoped=true&", function () {
      api.rerender('ebc826bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YefZh28hRBh2/JS/comp/Voucher-Unit.vue"
export default component.exports